<template>
  <div style="width: 100%;height:100%;">
    <!--背景视频-->
    <video style="position:absolute;width:100%;height:100%;object-fit:cover;" autoplay loop muted>
      <source src="https://market.obs.cn-north-4.myhuaweicloud.com:443/202405220957000598264.mp4" type="video/mp4" />
    </video>
    <v-layout row style="position: absolute;left: 25px;top: 25px">
      <v-img contain src="../../../assets/user_system/logoAndTitleNew.png" style="width:200px;flex:none;"></v-img>
    </v-layout>

    <div style="width: 400px;height: 525px;position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%)">
      <v-card class="card">
        <div style="height: 24px;">
          <div style="color:rgba(0, 0, 0, 1);font-size: 24px;float: left;line-height: 24px;font-weight: 400;">实名认证</div>
        </div>
        <div style="width: 283px;margin: 0 auto">
          <v-text-field class="pt-15"
              placeholder="请输入您的姓名"
              v-model="name"
              :rules = "requiredRule" validate-on-blur @focus="clearError"
              required>
            <template v-slot:message>
              <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;姓名不能为空</div>
            </template>
          </v-text-field>

          <v-text-field
              placeholder="请输入您的身份证号码"
              v-model="idNumber"
              :rules="idNumberRule" validate-on-blur @focus="clearError">
            <template v-slot:message>
              <div style="padding-top: 1px;padding-right: 1px" ><span class="iconfontFamily" style="font-size: 12px;color: rgba(255, 0, 0, 1)">&#xe612;</span>&nbsp;请输入格式正确的身份证号码</div>
            </template>
          </v-text-field>
          <div v-show="nameError" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;你本次输入的实名认证信息与已有实名信息不一致，请核对后重新输入</div>
          <div v-show="realNameAuthError" style="margin-top: -18px;color: rgba(255, 0, 0, 0.75);font-size: 12px" ><span class="iconfontFamily">&#xe612;</span>&nbsp;你输入的姓名或身份证号码不正确，请重新输入</div>

          <v-btn
              @click="realNameAuth"
              width="283px"
              height="40px"
              depressed
              :color="realNameAuthBtnClickable?'rgba(25, 118, 210, 1)':'rgba(140, 187, 233, 1)'"
              style="margin-top: 98px;color: white;font-size: 16px">
            确认提交
          </v-btn>
        </div>
        <div style="width: 296px;margin: 13px auto 0 auto;">
          <p style="text-align:justify;color:rgba(128, 128, 128, 0.7);font-size:12px;">根据国家相关政策要求，防范地理信息风险。你需要完成实名认证。用户信息将进行严格的隐私保护，请放心认证。</p>
        </div>

      </v-card>
    </div>

  </div>

</template>

<script>
export default {
  name: "RealNameAuth",
  data(){
    return{
      name:"",
      idNumber:"",
      requiredRule:[
        v => !!v || '不能为空',
      ],
      idNumberRule:[
        v => !!v || '不能为空',
        v => /(^\d{15}$)|(^\d{17}(\d|X)$)/i.test(v) || '身份证号码格式不正确',
      ],

      nameError:false,
      realNameAuthError:false
    }

  },
  computed:{
    realNameAuthBtnClickable(){
      return !!this.name && !!this.idNumber && (this.idNumber.length === 15 || this.idNumber.length === 18)
    },
  },
  methods:{
    //实名认证
    realNameAuth(){
      if(this.realNameAuthBtnClickable){
        this.nameError = false;
        this.realNameAuthError = false;

        this.$axios({
          method:"get",
          url:"/earthApi/vip-check-card-normal/addVipCheckCardNormal",
          params:{
            name:this.name,
            idCard:this.idNumber
          }
        }).then((resultData)=>{
          resultData = resultData.data;
          if(resultData.status === 200){
            if(resultData.data){
              //认证成功
              this.$store.state.snackbarShow=true
              this.$store.state.snackbarText = "实名认证成功"
              this.$store.state.snackbarType = 'success'
              setTimeout(()=>{
                this.$router.push({
                  path: '/globe',
                })
              },1000)

            }
            else{
              //认证失败
              this.nameError = false;
              this.realNameAuthError = true;
            }
          }
          else if(resultData.status === 4014){
            //姓名和以前实名认证的姓名不一致
            this.nameError = true;
            this.realNameAuthError = false;
          }
          else{
            //认证失败
            this.nameError = false;
            this.realNameAuthError = true;
          }
        }).catch((err)=>{
          console.log(err);
        });
      }
    },

    //输入过程中清空错误提示
    clearError(){
      this.nameError = false;
      this.realNameAuthError = false;
    }



  }


}
</script>

<style scoped>

.card{
  padding:40px 45px 0px 45px;
  width: 100%;
  height: 100%;
  position: relative;
}



</style>